import type { MeStats } from '../api/types';

function fmtLimit(n: number | null): string {
  return n === null ? '∞' : String(n);
}

const MB = 1_048_576;

// A compact "where you stand" panel so the user always sees usage vs plan limits
// (the freemium awareness surface). Numbers come straight from /me/stats, which
// reuses the same entitlement service that enforces the limits — so they agree.
// CHANGE_01: "projects" terminology, active-share-link cap, and a storage meter.
export default function UsageSummary({ stats }: { stats: MeStats }) {
  const usedMb = Math.round((stats.storage_bytes / MB) * 10) / 10;
  const rows = [
    { label: 'Active projects', used: stats.models.active, limit: stats.limits.max_active_projects },
    {
      label: 'Exports this month',
      used: stats.exports_this_window.used,
      limit: stats.exports_this_window.limit,
    },
    {
      label: 'Active share links',
      used: stats.active_share_links.used,
      limit: stats.active_share_links.limit,
    },
    {
      label: 'Storage (MB)',
      used: usedMb,
      limit: stats.limits.storage_mb,
    },
  ];
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {rows.map((r) => (
        <div key={r.label} className="rounded-lg border border-[var(--cad-panel-border,#27272a)] bg-[color-mix(in_srgb,var(--cad-panel-bg,#09090b)_40%,transparent)] p-3">
          <div className="text-xs text-[var(--cad-text-muted,#71717a)]">{r.label}</div>
          <div className="mt-1 text-sm text-[var(--cad-text,#f4f4f5)]">
            {r.used} <span className="text-[var(--cad-text-muted,#71717a)]">/ {fmtLimit(r.limit)}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
